//项目文件
import { Project } from "@/declare/interface/project";
import { ProjectFile } from "@/declare/interface/project-file";
import axios, { AxiosResponse } from "axios";
import { StdResponse, coreAxios } from "@/declare/api/axios"
import qs from 'qs';
// const CancelToken = axios.CancelToken;

/**
 * 根据项目查询下一级项目列表
 */
export function getSubProjectsByProjectId(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/sub-projects`, {
        params: params
    })
}

/**
 * 根据userId获取个人项目
 */
export function getPersonalProject(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/personal-project`, {
        params: { ...params, userId: userId }
    })
}

/**
 * 根据机构查询下一级机构对应的项目列表
 */
export function getSubProjectsByInstitutionId(institutionId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/institutions/${institutionId}/sub-projects`, {
        params: params
    })
}

export function addProject(project: Project, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects`, project, {
        params: params
    })
}

export function addStaffProject(project: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/staff-projects`, project, {
        params: params
    })
}

export function addProjectFromMarket(project: Project, activityId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/from-market`, project, {
        params: {
            ...params,
            activityId: activityId,
        }
    })
}

export function deleteProject(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectId}`, {
        params: params
    })
}

export function updateProject(projectId: number, project: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/projects/${projectId}`, project, {
        params: params
    })
}

export function getProject(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}`, {
        params: params
    })
}

export function getProjectAndStatistics(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/statistics`, {
        params: params
    })
}
/**
 * 查找项目列表
 * @param params 可选："isRecent", "userId",  "category","status",  
 * @returns 
 */
export function getProjects(params?: {}): Promise<AxiosResponse<any>> {
    // if (!!cancelGetProjects) {
    //     cancelGetProjects();
    // }
    return coreAxios.get(`/projects`, {
        params: params,
        // cancelToken: new CancelToken(function executor(c) {
        //     cancelGetProjects = c;
        // }),
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getProjectsAndStatistics(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/statistics`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getProjectStatisticsDividedByType(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/statistics/types`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getBusinessProjects(businessProjectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${businessProjectId}/business`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getPurchaseProjects(purchaseProjectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${purchaseProjectId}/purchase`, {
        params: params,
    })
}

export function getProjectNavs(userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/navs`, {
        params: {
            ...params,
            userId: userId,
        }
    })
}

/**
 * 获取项目参与人
 */
export function getProjectLinkedUsers(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/linked-users`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取项目经理
 * @param params 
 * @returns 
 */
export function getProjectLeaders(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/leaders`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获得项目统计 按部门统计的项目数量和项目产值 按项目经理统计的项目数量和项目产值
 */
export function getBusinessProjectStatistic(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/business-statistic`, {
        params: {
            ...params,
        }
    })
}
/**
 * 查询生产类项目列表
 *
 * 获得待分配的生产类项目
 *
 * 获得全部生产类项目
 *
 * 获得某个部门参与的项目
 *
 * 获得某个项目经理负责的项目
 */
export function getBusinessProjectsByQueryParams(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/business`, {
        params: {
            ...params,
        }
    })
}
/**
 * 查询体系建设类项目列表
 *
 * 获得全部
 *
 * 获得某个部门参与的
 */
export function getSystemConstructionProjectsByParams(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/system-construction`, {
        params: {
            ...params,
        }
    })
}


/**
 * 查找项目相关的项目列表以及每个项目参与的人员列表
 */
export function getProjectsAndUsersByProjectId(projectId: number | null, userId?: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/all-users`, {
        params: {
            ...params,
            userId,
        }
    })
}


/**
 * 获得项目规划，包括项目基本信息、关联的机构、可交付成果清单
 */
export function getProjectPlanning(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/planning`, {
        params: {
            ...params,
        }
    })
}

export function updateProjectNavHidden(userId: number, projectId: number, hidden: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/projects/navs`, null, {
        params: {
            ...params,
            userId,
            projectId,
            hidden,
        }
    })
}

export function getLogFileUrl(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/logFile/download`, {
        params: params
    })
}


/**
 * 获取项目文件树结构
 * @param projectId - 项目ID
 * @returns - AxiosResponse 包含文件树结构
 */
export function getProjectFilesTree(projectId: number): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files/tree`);
}

/**
 * 获取指定项目中的某个文件夹的子文件和子文件夹列表
 * 
 * @param {number} projectId - 当前项目的 ID，用于标识项目。
 * @param {number} folderId - 文件夹的 ID，用于标识父文件夹。
 * @returns {Promise<AxiosResponse<any>>} - 返回一个 Promise 对象，resolve 时包含 Axios 响应数据，通常是该文件夹下的子文件和子文件夹。
 * 
 * 这个函数会发起一个 GET 请求到服务器，目标路径为 `/projects/{projectId}/folders/{folderId}/children`，
 * 服务器返回指定文件夹（`folderId`）中的所有直接子项（可以是文件或文件夹），
 * 返回值通过 `coreAxios.get` 方法发起请求，并返回 Promise。调用者可以处理 Promise 的 resolve 或 reject 状态。
 */
export function getFolderChildren(projectId: number, folderId: number): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/folders/${folderId}/children`);
}

export function uploadProjectFile(projectId: number, data: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/files`, data, {
        params: params
    })
}

export function getProjectFiles(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files`, {
        params: params
    })
}
export function getProjectFile(projectId: number, fileId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files/${fileId}`, {
        params: params
    })
}
export function searchProjectFiles(projectId: number, searchStr: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files/search`, {
        params: {
            ...params,
            searchValue: searchStr,
        }
    })
}

export function findProjectPhotos(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/photos`, {
        params: {
            ...params,
        }
    })
}
export function findProjectPhotoFolder(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/photo-folder`, {
        params: {
            ...params,
        }
    })
}

export function getProjectFilesByTaskId(taskId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/tasks/${taskId}/files`, {
        params: params
    })
}

export function getFilePath(projectId: number, fileId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files/${fileId}/path`, {
        params: params
    })
}

export function getFilesInFolder(projectId: number, parentId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/folders/${parentId}/files`, {
        params: params
    })
}

export function getRootFolderId(projectId: number, fileId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/files/${fileId}/root`, {
        params: params
    })
}

export function addFolder(folder: ProjectFile, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/folders`, folder, {
        params: params
    })
}

export function addRecursiveFolders(projectId: number, folders: ProjectFile[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/folders/recursive`, folders, {
        params: params
    })
}

export function updateProjectFile(file: ProjectFile, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/projects/files`, file, {
        params: params
    })
}

export function deleteProjectFileMulti(fileIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/files/delete`, fileIds, {
        params: params
    })
}

export function moveProjectFileMulti(projectId: number, fileIds: number[], targetParentId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/files/move`, fileIds, {
        params: {
            ...params,
            targetParentId: targetParentId,
        }
    })
}

export function deleteProjectNavs(projectId: number, userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectId}/navs`, {
        params: {
            ...params,
            userId: userId,
        }
    })
}
export function deleteProjectNavsMulti(projectId: number, userIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/projects/${projectId}/navs-multi`, {
        params: {
            ...params,
            userIds: userIds,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function addProjectNavs(projectId: number, userIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/navs`, userIds, {
        params: {
            ...params,
            userIds: userIds,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function getProjectsAndStatisticsByDepartment(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/department/statistics`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function archiveProject(projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/archive`, {
        params: params
    })
}


export function downloadZip(projectId: number, folderId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectId}/folders/${folderId}/zip`, {
        params: {
            ...params,
        },
    })
}

export function copyProjectFileMulti(fileIds: number[], targetParentId: number, projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/files/copy`, fileIds, {
        params: {
            ...params,
            targetParentId: targetParentId,
        }
    })
}

export function getMostRelevantTasks4Files(fileIds: number[], projectId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/files/relevant`, fileIds, {
        params: {
            ...params,
            projectId: projectId,
        }
    })
}

/**
 * 判断哪些文件夹可以被删除
 * @param projectId 
 * @param Ids 
 * @param params 
 * @returns 
 */
export function checkFileListCanDelete(projectId: number, Ids: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectId}/check-delete`, Ids, {
        params: {
            ...params,
        }
    })
}